<template>
  <div>
    <vx-card heading-size="h1" class="mt-base mb-5" title="Student Help">
      <p class="mb-5">Need help? Everything you need is below.</p>

      <vs-tabs alignment="fixed" class="overwrite-tabs">
        <vs-tab label="Help Videos">
          <div class="tab-text my-5">
            <p class="mb-5">
              The videos below will help you will all parts of the Job Experience system.
            </p>

            <div role="list">
              <div
                class="vx-row mt-10 flex items-center"
                v-for="(item, index) in help_items_videos"
                :key="index"
                role="listitem"
              >
                <div class="vx-col lg:w-1/2 md:w-2/3 w-full mb-base">
                  <heading size="h2" style-size="h4">{{ item.title }}</heading>
                  <p class="mb-5" v-html="item.text"></p>
                </div>
                <div
                  class="vx-col lg:w-1/4 md:w-1/3 w-full mb-base pl-10"
                  @click="showVideoPopup(item.video, `video-btn-${index}`)"
                >
                  <button :id="`video-btn-${index}`">
                    <img
                      :src="item.image"
                      :alt="item.alt"
                      class="img-responsive mx-auto cursor-pointer"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  data() {
    return {
      sending: false,
      help_items_videos: [
        {
          title: 'Overview:',
          text: `A quick overview of the various part of the Virtual Job Experience platform.<br/><br/>
What is it, where is it and what does it do?`,
          image: require('@/assets/images/studenthelp/student_help_overview.jpg'),
          video: 'content/studenthelp/student_help_overview_1000.mp4',
          alt: 'overview',
        },
        {
          title: 'Pre Work Experience:',
          text: `This video covers the various activities you may be asked to do before starting your Virtual Job Experience or even school Work Experience.`,
          image: require('@/assets/images/studenthelp/student_help_pre_work.jpg'),
          video: 'content/studenthelp/student_help_pre_work_1000.mp4',
          alt: 'pre work experience',
        },
        {
          title: 'Completing Virtual Experiences:',
          text: `A complete walkthrough of how to select and complete a virtual experience.`,
          image: require('@/assets/images/studenthelp/student_help_virtual.jpg'),
          video: 'content/studenthelp/student_help_virtual_1000.mp4',
          alt: 'completing virtual experiences',
        },
        {
          title: '"Real World" Work Experience:',
          text: `Your teacher may ask you to use this system as part of your regular school Work Experience program. This video shows you how you do this.`,
          image: require('@/assets/images/studenthelp/student_help_real_world.jpg'),
          video: 'content/studenthelp/student_help_real_world_1000.mp4',
          alt: 'real world work experience',
        },
        {
          title: 'Post (After) Work Experience:',
          text: `You may be required to complete some steps after you have completed your experience. This videos steps you through these.`,
          image: require('@/assets/images/studenthelp/student_help_post_work.jpg'),
          video: 'content/studenthelp/student_help_post_work_1000.mp4',
          alt: 'post work experience',
        },
        {
          title: 'Work Experience Certificates (and Notifications):',
          text: `This is what you have been working towards. Work Experience certificates that you can use as part of your job search portfolio. The video will also show you the notification system that lets you know when you have certificates waiting for you.`,
          image: require('@/assets/images/studenthelp/student_help_certificates_notifications.jpg'),
          video: 'content/studenthelp/student_help_certificates_notifications_1000.mp4',
          alt: 'work experience certificates and notifications',
        },
      ],
      help_items_documents: [],
    };
  },
  computed: {
    helpPopupVisible: {
      get: function () {
        return this.$store.getters['popup/helpPopupVisible'];
      },
      set: function (d) {
        this.$store.commit('popup/setHelpPopupVisible', d);
      },
    },
  },
  methods: {
    showVideoPopup(url, elemId) {
      store.dispatch(
        'popup/showVideoPopup',
        $vjeConfig.VUE_APP_VJE_PUBLIC_OBJECT_STORAGE_URL + '/' + url,
      );
      store.commit('popup/setFocusElemOnPopupClose', elemId);
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  border: none;
}
</style>
